import React from "react";
import { Form, Modal } from "react-bootstrap";
import { ReactComponent as Whiteclose } from "../../assets/images/white-close.svg";
import { Backdrop, CircularProgress, Drawer } from "@mui/material";
import { NotificationManager } from "react-notifications";
import validator from "validator";
import { connect } from "react-redux";
import { selectemployeeData } from "../../store/home/home.selectors";
import { bindActionCreators } from "redux";
import { ReactComponent as Edit } from "../../assets/images/Edit.svg";
import { ReactComponent as Blackclose } from "../../assets/images/black-close.svg";
import UserService from "../../services/user/user.service";
import AppConfig from "../../config/app.config";
import { setEmployeeData } from "../../store/home/home.actions";

const removeExtraSpace = (s) => s.trim().replace(/\s/g, "");

const mapStateToProps = (state) => {
  return {
    employeeData: selectemployeeData(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      setEmployeeData,
    },
    dispatch
  ),
});

class AccountOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: 1,
      profile: null,

      isEditable: false,

      userName: "",
      profilePic: null,
      profilePicSource: null,
      email: "",

      favoriteCount: 0,
    };
  }

  componentDidMount() {
    if (this.props.employeeData?.employeeId == null) {
      this.props.close();
    } else {
      this.setState({ isLoading: 1 });
      this.getEmployeeProfileData();
      this.getFavoriteCount();
      this.setState({ isLoading: 0 });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.visible !== prevProps.visible &&
      this.props.visible === true
    ) {
      this.setState({ isLoading: 1 });
      this.getEmployeeProfileData();
      this.getFavoriteCount();
      this.setState({ isLoading: 0 });
    }
  }

  getEmployeeProfileData = async () => {
    if (this.props.employeeData?.employeeId != null) {
      try {
        const res = await UserService.getEmployeeProfileDetail(
          this.props.employeeData?.employeeId
        );
        if (res.error != null) {
          if (res.error?.response?.data?.message != null) {
            NotificationManager.error(
              "",
              res.error.response.data.message,
              3000
            );
          } else {
            NotificationManager.error("", "Could not get Profile Data.", 3000);
          }
        } else {
          if (res["status"]) {
            const data = res["data"];
            if (data == null) {
              NotificationManager.error(
                "",
                "Could not get Profile Data.",
                3000
              );
            } else {
              this.setState({
                profile: data,
                profilePic: null,
                profilePicSource:
                  AppConfig.API.USER_PROFILE +
                  this.props.employeeData?.employeeId,
                userName: data.name,
                email: data.email,

                isEditable: false,
              });
            }
          } else {
            NotificationManager.error("", "Could not get Profile Data.", 3000);
          }
        }
      } catch (err) {}
    }
  };

  getFavoriteCount = async () => {
    if (this.props.employeeData?.employeeId != null) {
      try {
        const res = await UserService.getTotalFavoriteCount(
          this.props.employeeData?.employeeId
        );
        if (res.error != null) {
          if (res.error?.response?.data?.message != null) {
            NotificationManager.error(
              "",
              res.error.response.data.message,
              3000
            );
          } else {
            NotificationManager.error("", "Could not get Profile Data.", 3000);
          }
        } else {
          if (res["status"]) {
            const data = res["data"];
            if (data == null) {
              NotificationManager.error(
                "",
                "Could not get Total Favorite Count.",
                3000
              );
            } else {
              this.setState({
                favoriteCount: data?.totalFavoriteCount,
              });
            }
          } else {
            NotificationManager.error(
              "",
              "Could not get Total Favorite Count.",
              3000
            );
          }
        }
      } catch (err) {}
    }
  };

  handleProfilePic = (event) => {
    var reader = new FileReader();
    reader.onload = (e) => {
      this.setState({ profilePicSource: e.target.result });
    };
    reader.readAsDataURL(event.target.files[0]);
    this.setState({ profilePic: event.target.files[0] });
  };

  handleUserName = (event) => {
    this.setState({ userName: event.target.value });
  };

  handleEmail = (event) => {
    this.setState({ email: removeExtraSpace(event.target.value) });
  };

  saveAccountInfo = async () => {
    if (this.state.userName.trim() === "") {
      NotificationManager.warning("Please Enter User Name.", "", 2000);
    } else if (this.state.email.trim() === "") {
      NotificationManager.warning("Please Enter Email.", "", 2000);
    } else if (!validator.isEmail(this.state.email)) {
      NotificationManager.warning("Please Enter Valid Email.", "", 2000);
    } else {
      this.setState({ isLoading: 1 });
      if (this.props.employeeData?.employeeId != null) {
        try {
          const payload = {
            photo: this.state.profilePicSource.split(",")[1],
            name: this.state.userName,
          };
          const res = await UserService.saveEmployeeProfileDetail(
            this.props.employeeData?.employeeId,
            payload
          );
          if (res.error != null) {
            if (res.error?.response?.data?.message != null) {
              NotificationManager.error(
                "",
                res.error.response.data.message,
                3000
              );
            } else {
              NotificationManager.error(
                "",
                "Could not save Profile Data.",
                3000
              );
            }
            this.setState({ isLoading: 0 });
          } else {
            if (res["status"]) {
              const data = res["data"];
              if (data == null) {
                NotificationManager.error(
                  "",
                  "Could not save Profile Data.",
                  3000
                );
                this.setState({ isLoading: 0 });
              } else {
                this.setState({
                  profilePic: null,
                  isLoading: 0,
                  isEditable: false,
                });
                const newEmpData = {
                  ...this.props.employeeData,
                  name: this.state.userName,
                };
                localStorage.setItem("employeeName", this.state.userName);
                localStorage.setItem(
                  "employeeData",
                  JSON.stringify(newEmpData)
                );
                window.location.reload(false);
              }
            } else {
              NotificationManager.error(
                "",
                "Could not save Profile Data.",
                3000
              );
              this.setState({ isLoading: 0 });
            }
          }
        } catch (err) {
          this.setState({ isLoading: 0 });
        }
      }
    }
  };

  render() {
    return (
      <>
        <Modal
          enforceFocus={false}
          show={this.props.visible}
          onHide={this.props.close}
          backdrop="static"
          keyboard={false}
          centered={true}
          id="account-modal"
        >
          {this.state.isLoading === 1 && (
            <Backdrop style={{ zIndex: 9999999, color: "#fa96c8" }} open>
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
          <div className="right-closeicon">
            <Blackclose className="closeicon" onClick={this.props.close} />
          </div>
          <div className="accountmodal-close">
            <div className="Favorites-profile">
              <div className="profile-picture">
                <div className="profile-img" style={{ position: "relative" }}>
                  {this.state.profilePicSource != null && (
                    <img
                      src={this.state.profilePicSource}
                      alt=""
                      className="account-profileimg"
                    />
                  )}
                  {this.state.isEditable === true && (
                    <>
                      <label htmlFor="files" className="profiledetails-edit">
                        <Edit />
                      </label>
                      <input
                        className="input-field"
                        id="files"
                        type="file"
                        accept="image/*"
                        onChange={this.handleProfilePic}
                      />
                    </>
                  )}
                </div>
                <h4>Profile picture </h4>
              </div>
              <div className="profile-Favorites">
                <img
                  src={require("../../assets/images/heart.png")}
                  className="heart-img"
                  alt="heart"
                />
                <p>
                  <span>{this.state.favoriteCount ?? 0}</span>
                  <span
                    onClick={() => {
                      this.props.history.push("/favorites");
                      this.props.close();
                    }}
                    className="fav-text"
                  >
                    Favorites
                  </span>
                </p>
              </div>
            </div>
            <h5>My Profile</h5>
            <div className="account-profileinfo-field">
              <div className="account-profileinfo-left">
                <p>Username</p>
              </div>
              <div className="account-profileinfo-right">
                <Form.Group>
                  <Form.Control
                    type="text"
                    className="mb-0 account-name"
                    maxLength="20"
                    placeholder="Username"
                    required
                    value={this.state.userName}
                    onChange={this.handleUserName}
                    disabled={!this.state.isEditable}
                    onKeyDown={(e) => {
                      if (e.key === " ") {
                        e.preventDefault();
                      }
                    }}
                    autoComplete="off"
                  />
                </Form.Group>
              </div>
            </div>
            <div className="account-profileinfo-field">
              <div className="account-profileinfo-left">
                <p>Email</p>
              </div>
              <div className="account-profileinfo-right">
                <Form.Group>
                  <Form.Control
                    type="email"
                    className="mb-0 account-name"
                    placeholder="Email"
                    value={this.state.email}
                    onChange={this.handleEmail}
                    disabled={true}
                    onKeyDown={(e) => {
                      if (e.key === " ") {
                        e.preventDefault();
                      }
                    }}
                    autoComplete="off"
                    required
                  />
                </Form.Group>
              </div>
            </div>
            <div className="profile-edit-btn">
              <button
                type="button"
                className="profile-edit"
                onClick={() => {
                  if (this.state.isEditable) {
                    this.saveAccountInfo();
                  } else {
                    this.setState({ isEditable: true });
                  }
                }}
              >
                {this.state.isEditable ? "Save" : "Edit"}
              </button>
            </div>
          </div>
        </Modal>

        <Drawer
          anchor="right"
          open={this.props.visible}
          onClose={this.props.close}
          id="set-mob-drawer"
        >
          {this.state.isLoading === 1 && (
            <Backdrop style={{ zIndex: 9999999, color: "#fa96c8" }} open>
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
          <div id="togglemenu-mobile">
            <div className="close-icon">
              <Whiteclose
                className="drawerclose-icon"
                onClick={this.props.close}
              />
            </div>
            <div className="mobile-registration">
              <div className="mobile-register">
                <p>My Account</p>
              </div>
              <div className="profile-box">
                <div className="Favorites-profile">
                  <div className="profile-picture">
                    <div
                      className="profile-img"
                      style={{ position: "relative" }}
                    >
                      {this.state.profilePicSource != null && (
                        <img src={this.state.profilePicSource} alt="" />
                      )}
                      {this.state.isEditable === true && (
                        <>
                          <label
                            htmlFor="files"
                            className="profiledetails-edit"
                          >
                            <Edit />
                          </label>
                          <input
                            className="input-field"
                            id="files"
                            type="file"
                            accept="image/*"
                            onChange={this.handleProfilePic}
                          />
                        </>
                      )}
                    </div>
                    <h4>Profile picture </h4>
                  </div>
                  <div className="profile-Favorites">
                    <img
                      src={require("../../assets/images/heart.png")}
                      className="heart-img"
                      alt="heart"
                    />
                    <p>
                      <span>{this.state.favoriteCount ?? 0}</span>
                      <span
                        onClick={() => {
                          this.props.history.push("/favorites");
                          this.props.close();
                        }}
                        className="fav-text"
                      >
                        Favorites
                      </span>
                    </p>
                  </div>
                </div>
                <h5>My Profile</h5>
                <div className="account-profileinfo-field">
                  <div className="account-profileinfo-left">
                    <p>Username</p>
                  </div>
                  <div className="account-profileinfo-right">
                    <Form.Group>
                      <Form.Control
                        type="text"
                        className="mb-0 account-name"
                        maxLength="20"
                        placeholder="username"
                        required
                        autoComplete="off"
                        value={this.state.userName}
                        onChange={this.handleUserName}
                        disabled={!this.state.isEditable}
                        onKeyDown={(e) => {
                          if (e.key === " ") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="account-profileinfo-field">
                  <div className="account-profileinfo-left">
                    <p>Email</p>
                  </div>
                  <div className="account-profileinfo-right">
                    <Form.Group>
                      <Form.Control
                        type="email"
                        className="mb-0 account-name"
                        placeholder="email"
                        autoComplete="off"
                        required
                        value={this.state.email}
                        onChange={this.handleEmail}
                        disabled={true}
                        onKeyDown={(e) => {
                          if (e.key === " ") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="profile-edit-btn">
                  <button
                    type="button"
                    className="profile-edit"
                    onClick={() => {
                      if (this.state.isEditable) {
                        this.saveAccountInfo();
                      } else {
                        this.setState({ isEditable: true });
                      }
                    }}
                  >
                    {this.state.isEditable ? "Save" : "Edit"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Drawer>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountOverlay);
